export default function ExpandIcon({ width = 19, height = 19, className, style, fill = '#EAEAEA' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 19 19"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M6.09606e-06 17.6758C6.08553e-06 18.0657 0.316101 18.3818 0.706024 18.3818L7.06019 18.3818C7.45011 18.3818 7.76621 18.0657 7.76621 17.6758C7.76621 17.2859 7.45011 16.9698 7.06019 16.9698L1.41204 16.9698L1.41204 11.3216C1.41204 10.9317 1.09595 10.6156 0.706024 10.6156C0.316101 10.6156 5.80103e-06 10.9317 5.96962e-06 11.3216L6.09606e-06 17.6758ZM18.3826 0.705219C18.3826 0.315295 18.0665 -0.000799798 17.6766 -0.000798755L11.3224 -0.000799577C10.9325 -0.000799914 10.6164 0.315296 10.6164 0.705219C10.6164 1.09514 10.9325 1.41124 11.3224 1.41124L16.9706 1.41124L16.9706 7.05938C16.9706 7.4493 17.2867 7.7654 17.6766 7.7654C18.0665 7.7654 18.3826 7.4493 18.3826 7.05938L18.3826 0.705219ZM0.706024 17.6758L1.20525 18.175L18.1758 1.20445L17.6766 0.705219L17.1774 0.205989L0.206794 17.1766L0.706024 17.6758Z"
                fill={fill}
            />
        </svg>
    );
}
